import api from '@/api';

class PropertyDocument {
  /**
   * @returns {AxiosPromise<any>}
   */
  static find(propertyId, propertyFileId) {
    return api.get(`/properties/${propertyId}/file/${propertyFileId}`);
  }
  /**
   * Index / Get listing of properties
   * @returns {*}
   */
  static list(propertyId) {
    return api.get(`/properties/${propertyId}/files`);
  }
  /**
   * Delete a property file
   * @returns {*}
   */
  static delete(propertyId, propertyFileIds) {
    return api.delete(`/properties/${propertyId}/files`, { params: { propertyFileIds } });
  }

  /**
   * Delete a property file
   *
   * @param propertyId
   * @param propertyFileIds
   * @param expiryDate
   * @param issueDate
   * @param propertyFileTypeId
   *
   * @returns {AxiosPromise<any>}
   */
  static updateType(propertyId, propertyFileIds, expiryDate, issueDate, propertyFileTypeId) {
    return api.post(
      `/properties/${propertyId}/files/update-type`,
      {
        propertyFileTypeId,
        propertyFileIds,
        expiryDate,
        issueDate,
      },
    );
  }
}

export default PropertyDocument;
